import {isOutOfStock, Product} from "@/entities/product";
import {AddToWaitListButton} from "@/features/add-to-waitList/ui/AddToWaitListButton";
import {QuickViewButton} from "@/features/quickView/ui/QuickViewButton";
import {BasketActionButton} from "@/features/basket-actions";

type Props = {
    product: Product;
    isIcon?: boolean;
};

export const CatalogCardButtons = ({product, isIcon}: Props) => {
    return (
        <>
            {isOutOfStock(product) ? (
                <AddToWaitListButton
                    productId={product.id}
                    fill={isIcon ? "text" : undefined}
                    size={isIcon ? "s" : undefined}
                    variant={isIcon ? "icon" : undefined}
                    fullWidth
                >
                    В лист ожидания
                </AddToWaitListButton>
            ) : (
                <BasketActionButton
                    product={product}
                    fill={isIcon ? "text" : undefined}
                    size={isIcon ? "s" : undefined}
                    variant={isIcon ? "icon" : undefined}
                    fullWidth
                />
            )}
            <QuickViewButton article={product.article} />
        </>
    );
};
